import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import HeadBar, { CustomView, HeadBarProps } from './core/HeadBar'
import Provider, { ProviderProps } from './core/Provider'
import Table, { TableProps } from './core/Table'

type DataTableProps<
  Paths,
  Filters,
  SortFields extends string,
  ExportFileName extends string,
  CustomViews extends CustomView[],
> = ProviderProps<Paths, Filters, SortFields> &
  TableProps &
  HeadBarProps<ExportFileName, CustomViews>

function DataTable<
  Paths,
  Filters,
  SortFields extends string,
  ExportFileName extends string,
  CustomViews extends CustomView[],
>({
  source,
  pagination,
  sort,
  filters,
  rowTo,
  density,
  emptyState,
  selectable,
  actions,
  toolbar,
  persistFilters,
  enableClearFilters,
  queryContext,
  autoWidth,
  ...otherHeadBarProps
}: DataTableProps<Paths, Filters, SortFields, ExportFileName, CustomViews>) {
  const providerProps: ProviderProps<Paths, Filters, SortFields> = {
    source,
    pagination,
    sort,
    filters,
    rowTo,
    persistFilters,
    enableClearFilters,
    queryContext,
  }
  const tableProps = { density, emptyState, selectable, autoWidth }
  const headBarProps = { actions, toolbar, ...otherHeadBarProps }

  return (
    <DataTable.Provider {...providerProps}>
      <Box gap="s16">
        <DataTable.HeadBar {...headBarProps} />
        <DataTable.Table {...tableProps} />
      </Box>
    </DataTable.Provider>
  )
}

DataTable.Provider = Provider
DataTable.Table = Table
DataTable.HeadBar = HeadBar

export { default as useDataTable } from './hooks/useDataTable'

export default DataTable
